import React from 'react'
import {
    Routes,
    Route,
    Navigate
} from 'react-router-dom'

import Home from '../pages/Home'
import Tour from '../pages/Tour'
import TourDetails from '../pages/TourDetails'
import Login from '../pages/Login'
import Register from '../pages/Register'
import SearchResultList from '../pages/SearchResult'
import ThankYou from '../pages/ThankYou'

const Router = () => {
  return (
    <Routes>
        <Route path='/' element={<Navigate to='/home'/>}/>
        <Route path='/home' element={<Home />} />
        <Route path='/tours' element={<Tour/>} />
        <Route path='/tours/:id' element={<TourDetails />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/thank-you' element={<ThankYou />} />
        <Route path='/tour/search' element={<SearchResultList />} />
    </Routes>
  )
}

export default Router